import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LocationsComponent } from './locations.component';
import { AuthGuard } from '../../services/auth-guard.service';
import { DynamicFormModule } from '../shared/controls/dynamic/dynamic-form.component';
import { LoadingModule } from '../shared/controls/loading.component';
import { NotesModule } from '../shared/controls/notes.component';
import { LastUpdatedModule } from '../shared/controls/last-updated.component';

import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { LocationListComponent } from './location-list.component';
import { SortIconCustomModule } from '../shared/controls/dynamic/sort-icon-custom.component';
import { DynamicValueModule } from '../shared/controls/dynamic/dynamic-value.component';
import { LocationDetailComponent } from './location-detail.component';
import { LocationFormModule } from './location-form.component';
import { SimpleControlModule } from '../shared/controls/dynamic/simple-control.component';
import { PaginatorCustomModule } from '../shared/controls/dynamic/paginator-custom.component';
import { KebobMenuModule } from '../shared/controls/dynamic/kebob-menu.component';
import { OrderFormModule } from '../orders/order-form.component';
import { UserFormModule } from '../users/user-form.component';
import { RowToolsModule } from '../shared/controls/row-tools.component';
import { NotesDetailModule } from '../shared/controls/notes-detail.component';
import { ContactsFormModule } from '../shared/controls/contacts-form.component';
import { ContactsDetailModule } from '../shared/controls/contacts-detail.component';




@NgModule({
  declarations: [
    LocationsComponent,
    LocationListComponent,
    LocationDetailComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    NotesModule,
    DialogModule,
    LoadingModule,
    ButtonModule,
    LastUpdatedModule,
    SortIconCustomModule,
    PaginatorCustomModule,
    DynamicValueModule,
    KebobMenuModule,
    UserFormModule,
    OrderFormModule,
    RowToolsModule,
    NotesDetailModule,
    ContactsFormModule,
    ContactsDetailModule,
    LocationFormModule,
    RouterModule.forChild([
      {
        path: '',
        component: LocationsComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: LocationListComponent, canActivate: [AuthGuard] },
        ]
      }
    ])
  ],
  exports: [
    LocationsComponent,
    LocationDetailComponent
  ]
})
export class LocationsModule { }

